<div [formGroup]="itemGroup" fxLayout="row wrap" (keydown.enter)="$event.preventDefault()">
    <mat-tab-group #mainTabs fxFlex="grow" class="main-item-tabs">
        <mat-tab #mainTab label="Content" i18n-label>
            <div fxLayout="row wrap" fxFlex="1 1 100%" fxLayoutAlign="start start">
                <mat-form-field
                    class="can-update-control"
                    fxFlex="0 1 100%"
                    *ngIf="itemGroup.get('item_type_value').value !== ItemTypes.QUESTION"
                >
                    <input matInput type="text" #title formControlName="title" placeholder="Title" i18n-placeholder />
                    <ng-container *ngIf="selectedResource$ | async; let selectedResource">
                        <mat-icon
                            matTooltip="Update title from original resource"
                            i18n-matTooltip
                            matSuffix
                            [ngClass]="{
                                grey: selectedResource?.title === itemGroup.value.title,
                                orange: selectedResource?.title !== itemGroup.value.title
                            }"
                            (click)="$event.stopPropagation(); updateItemFromResource(selectedResource, 'title')"
                        >
                            update
                        </mat-icon>
                    </ng-container>
                </mat-form-field>

                <mat-form-field
                    class="can-update-control"
                    fxFlex="0 1 100%"
                    *ngIf="itemGroup.get('item_type_value').value !== ItemTypes.QUESTION"
                >
                    <textarea
                        #summary
                        matInput
                        minRows="2"
                        cdkTextareaAutosize
                        #autosize="cdkTextareaAutosize"
                        cdkAutosizeMinRows="1"
                        cdkAutosizeMaxRows="10"
                        placeholder="Summary"
                        i18n-placeholder="@@summary"
                        formControlName="bullets"
                    ></textarea>
                    <ng-container *ngIf="selectedResource$ | async; let selectedResource">
                        <mat-icon
                            matTooltip="Update summary from original resource"
                            i18n-matTooltip
                            matSuffix
                            [ngClass]="{
                                grey: selectedResource?.bullets === itemGroup.value.bullets,
                                orange: selectedResource?.bullets !== itemGroup.value.bullets
                            }"
                            (click)="$event.stopPropagation(); updateItemFromResource(selectedResource, 'bullets')"
                        >
                            update
                        </mat-icon>
                    </ng-container>
                </mat-form-field>
            </div>

            <ng-container [ngSwitch]="itemGroup.value.item_type_value">
                <app-resource-builder-course
                    *ngSwitchCase="ItemTypes.COURSE"
                    fxFlex="1 1 100%"
                    [item]="item"
                    [selection]="selection"
                    [childGroup]="itemGroup"
                    (onSubmitThenRoute)="onSubmitThenRoute.emit($event)"
                ></app-resource-builder-course>

                <app-resource-builder-test
                    #itemDirective
                    *ngSwitchCase="ItemTypes.TEST"
                    fxFlex="1 1 100%"
                    [item]="item"
                    [selection]="selection"
                    [childGroup]="itemGroup"
                    (onResourceExist)="onResourceExist($event)"
                    (onSubmitThenRoute)="onSubmitThenRoute.emit($event)"
                ></app-resource-builder-test>

                <app-resource-builder-survey
                    #itemDirective
                    *ngSwitchCase="ItemTypes.SURVEY"
                    fxFlex="1 1 100%"
                    [item]="item"
                    [selection]="selection"
                    [childGroup]="itemGroup"
                    (onResourceExist)="onResourceExist($event)"
                    (onSubmitThenRoute)="onSubmitThenRoute.emit($event)"
                ></app-resource-builder-survey>
                <app-resource-builder-scorm
                    #itemDirective
                    *ngSwitchCase="ItemTypes.SCORM"
                    fxFlex="1 1 100%"
                    [item]="item"
                    [selection]="selection"
                    [childGroup]="itemGroup"
                    (onResourceExist)="onResourceExist($event)"
                    (onSubmitThenRoute)="onSubmitThenRoute.emit($event)"
                ></app-resource-builder-scorm>
                <app-resource-builder-event
                    #itemDirective
                    *ngSwitchCase="ItemTypes.EVENT"
                    fxFlex="1 1 100%"
                    [item]="item"
                    [selection]="selection"
                    [childGroup]="itemGroup"
                    (onResourceExist)="onResourceExist($event)"
                    (onSubmitThenRoute)="onSubmitThenRoute.emit($event)"
                ></app-resource-builder-event>
            </ng-container>
        </mat-tab>

        <mat-tab #mainTab label="Extra" i18n-label>
            <ng-template matTabContent>
                <div fxLayout="column" fxFlex="1 1 100%" fxLayoutAlign="start start" fxLayoutGap="1em">
                    <ng-container *ngIf="selectedResource$ | async; let selectedResource">
                        <app-image-view
                            *ngIf="selectedResource?.media$"
                            [media_id]="selectedResource.media$"
                            [proportional]="true"
                        ></app-image-view>
                        <div
                            class="mt-1 mb-1"
                            *ngIf="resourceTags$ | async; let tags"
                            fxFlex="0 1 100%"
                            fxLayoutAlign="start center"
                            fxLayoutGap="10px"
                        >
                            <mat-chip-list>
                                <mat-chip class="tags" (click)="showTagResources(tag)" *ngFor="let tag of tags"
                                    >{{ tag.name }}
                                    <app-language-selector
                                        class="flag tag-chip-lang-select"
                                        fxFlex="0 0 auto"
                                        [language_id]="tag.language_id"
                                    >
                                    </app-language-selector
                                ></mat-chip>
                            </mat-chip-list>
                        </div>
                    </ng-container>
                    <mat-accordion fxFlex="0 1 100%" displayMode="flat" class="w-100">
                        <mat-expansion-panel #expansionPanelDesc [expanded]="true">
                            <mat-expansion-panel-header class="pl-0">
                                <mat-panel-title fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="5px">
                                    <mat-icon>description</mat-icon>
                                    <div i18n>Description</div>
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <ng-template matExpansionPanelContent>
                                <mat-form-field class="summary-field" fxFlex="0 1 100%">
                                    <textarea
                                        #desc
                                        matInput
                                        placeholder="Write a description and list what you will learn in this course. Why the learner shall spend time and what will be the benefit of take the Course."
                                        i18n-placeholder
                                        minRows="3"
                                        formControlName="description"
                                    ></textarea>
                                </mat-form-field>
                            </ng-template>
                        </mat-expansion-panel>
                    </mat-accordion>
                    <ng-container *ngIf="selectedResource$ | async; let selectedResource">
                        <mat-accordion fxFlex="0 1 100%" displayMode="flat" class="w-100">
                            <mat-expansion-panel #expansionPanelcode [expanded]="true">
                                <mat-expansion-panel-header class="pl-0">
                                    <mat-panel-title fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="5px">
                                        <mat-icon>info</mat-icon>
                                        <div i18n="@@other_info">Other information</div>
                                    </mat-panel-title>
                                </mat-expansion-panel-header>
                                <ng-template matExpansionPanelContent>
                                    <mat-form-field fxFlex="0 1 100%">
                                        <textarea
                                            #otherInfo
                                            matInput
                                            placeholder="Enter other information"
                                            i18n-placeholder
                                            minRows="2"
                                            cdkTextareaAutosize
                                            #autosize="cdkTextareaAutosize"
                                            cdkAutosizeMinRows="1"
                                            cdkAutosizeMaxRows="10"
                                            maxLength="1000"
                                            [formControl]="otherInfoFormControl"
                                        ></textarea>
                                        <span *ngIf="otherInfo.value" class="char-count">
                                            {{ otherInfo.value.length }}
                                            <span>(</span>
                                            {{ 1000 - otherInfo.value.length }}
                                            <span i18n="@@left">left</span>
                                            <span>)</span>
                                        </span>
                                    </mat-form-field>
                                </ng-template>
                            </mat-expansion-panel>
                        </mat-accordion>
                    </ng-container>
                    <mat-accordion
                        fxFlex="0 1 100%"
                        displayMode="flat"
                        class="w-100"
                        *ngIf="selectedResource$ | async; let selectedResource"
                    >
                        <mat-expansion-panel #expansionPanelDesc [expanded]="true">
                            <mat-expansion-panel-header class="pl-0">
                                <mat-panel-title fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="5px">
                                    <mat-icon>video_library</mat-icon>
                                    <div i18n>Trailer</div>
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <ng-template matExpansionPanelContent>
                                <app-video-link-control
                                    class="trailer-uploader-wrapper"
                                    [formControl]="trailerFormControl"
                                    [uploaderBtnLabel]="'Upload trailer'"
                                    i18n-uploaderBtnLabel="@@uploadTrailer"
                                    (mediaUploaded)="onTrailerUploaded($event, selectedResource)"
                                    (mediaCleared)="onTrailerCleared(selectedResource)"
                                ></app-video-link-control>
                            </ng-template>
                        </mat-expansion-panel>
                    </mat-accordion>
                    <ng-container *ngIf="selectedResource$ | async; let selectedResource">
                        <mat-accordion
                            *ngIf="
                                itemGroup.value.item_type_value === ItemTypes.COURSE ||
                                itemGroup.value.item_type_value === ItemTypes.SCORM ||
                                itemGroup.value.item_type_value === ItemTypes.EVENT
                            "
                            fxFlex="0 1 100%"
                            displayMode="flat"
                            class="w-100"
                        >
                            <mat-expansion-panel #expansionPanelcode [expanded]="true">
                                <mat-expansion-panel-header class="pl-0">
                                    <mat-panel-title fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="5px">
                                        <mat-icon>fingerprint</mat-icon>
                                        <div i18n="@@SKU-ArticleNumber">SKU/ Article number</div>
                                    </mat-panel-title>
                                </mat-expansion-panel-header>
                                <ng-template matExpansionPanelContent>
                                    <app-resource-article-code-form
                                        fxFlex="0 1 100%"
                                        [formControl]="articleCode"
                                        [resourceId]="selectedResource?.id"
                                        placeholder="Please set SCORM code"
                                        i18n-placeholder
                                        (onValueUpdated)="onArticleCodeUpdated($event, selectedResource)"
                                    ></app-resource-article-code-form>
                                </ng-template>
                            </mat-expansion-panel>
                        </mat-accordion>
                    </ng-container>

                    <mat-accordion
                        fxFlex="0 1 100%"
                        displayMode="flat"
                        class="w-100"
                        *ngIf="itemGroup.value.item_type_value === ItemTypes.MATERIAL"
                    >
                        <mat-expansion-panel #expansionPanelDesc>
                            <mat-expansion-panel-header>
                                <div *ngIf="!expansionPanelDesc.expanded" i18n="@@contentInformation">
                                    Content information
                                </div>
                            </mat-expansion-panel-header>
                            <ng-template matExpansionPanelContent>
                                <app-text-editor
                                    fxFlex="1 1 100%"
                                    title="Content information"
                                    i18n-title
                                    [showTemplates]="false"
                                    formControlName="instructions"
                                ></app-text-editor>
                            </ng-template>
                        </mat-expansion-panel>
                    </mat-accordion>
                </div>
            </ng-template>
        </mat-tab>
    </mat-tab-group>
</div>
